import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaMale, FaFemale, FaSignOutAlt, FaChartLine, FaImages, FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';
import Credits from '../Credits/Credits';
import { logout } from '../../api/api';

const Navbar = () => {
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const updateUserProfile = () => {
    const profile = localStorage.getItem('userProfile');
    if (profile) {
      try {
        setUserProfile(JSON.parse(profile));
      } catch (error) {
        console.error('Error parsing user profile:', error);
        setUserProfile(null);
      }
    } else {
      setUserProfile(null);
    }
  };

  useEffect(() => {
    updateUserProfile();
    const handleStorageChange = (e) => {
      if (!e.key || e.key === 'userProfile') {
        updateUserProfile();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('storage-local', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('storage-local', handleStorageChange);
    };
  }, []);

  // Handle body class for mobile menu
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }

    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isMobileMenuOpen]);

  const getProfileIcon = () => {
    if (!userProfile) return <FaUser />;
    return userProfile?.gender === 'male' ? <FaMale /> : 
           userProfile?.gender === 'female' ? <FaFemale /> : 
           <FaUser />;
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userProfile');
      localStorage.removeItem('userCredits');
      localStorage.removeItem('userId');
      setUserProfile(null);
      navigate('/sign-in');
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="main-nav">
        <div className="main-nav-container">
          <div className="main-nav-left">
            <Link to="/" className="main-nav-logo">
              InspiraPix
            </Link>
            <Link to="/explore" className="main-nav-item">
              Explore
            </Link>
            <Link to="/packages" className="main-nav-item">
              Pricing
            </Link>
            <button className="main-nav-mobile-toggle" onClick={toggleMobileMenu}>
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="main-nav-center">
            {userProfile && (
              <>
                <Link to="/generate" className="main-nav-item">
                  <FaChartLine />
                  <span>Generate</span>
                </Link>
                <Link to="/gallery" className="main-nav-item">
                  <FaImages />
                  <span>Gallery</span>
                </Link>
              </>
            )}
          </div>

          <div className="main-nav-right">
            {userProfile ? (
              <>
                <Credits />
                <Link to="/profile" className="main-nav-item main-nav-profile">
                  {getProfileIcon()}
                  <span>{userProfile?.username}</span>
                </Link>
                <button 
                  onClick={handleLogout}
                  className="main-nav-button main-nav-logout"
                >
                  <FaSignOutAlt />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link to="/sign-in" className="main-nav-item">
                  Sign in
                </Link>
                <Link to="/sign-up" className="main-nav-button">
                  Sign Up
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu */}
          <div className={`main-nav-mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <Link 
              to="/explore" 
              className="main-nav-item"
              onClick={closeMobileMenu}
            >
              Explore
            </Link>
            <Link 
              to="/packages" 
              className="main-nav-item"
              onClick={closeMobileMenu}
            >
              Pricing
            </Link>
            {userProfile && (
              <>
                <Link 
                  to="/generate" 
                  className="main-nav-item"
                  onClick={closeMobileMenu}
                >
                  <FaChartLine />
                  <span>Generate</span>
                </Link>
                <Link 
                  to="/gallery" 
                  className="main-nav-item"
                  onClick={closeMobileMenu}
                >
                  <FaImages />
                  <span>Gallery</span>
                </Link>
              </>
            )}
            
            {userProfile ? (
              <>
                <div className="credits-container">
                  <Credits />
                </div>
                <Link 
                  to="/profile" 
                  className="main-nav-item main-nav-profile"
                  onClick={closeMobileMenu}
                >
                  {getProfileIcon()}
                  <span>{userProfile?.username}</span>
                </Link>
                <button 
                  onClick={() => {
                    handleLogout();
                    closeMobileMenu();
                  }} 
                  className="main-nav-button main-nav-logout"
                >
                  <FaSignOutAlt />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link 
                  to="/sign-in" 
                  className="main-nav-item"
                  onClick={closeMobileMenu}
                >
                  Sign in
                </Link>
                <Link 
                  to="/sign-up" 
                  className="main-nav-button"
                  onClick={closeMobileMenu}
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>
      
      {/* Overlay */}
      <div 
        className={`main-nav-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />
    </>
  );
};

export default Navbar; 